import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button, Notification } from 'suomifi-ui-components';
import styled from 'styled-components';

const StyledContent = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const StyledNotification = styled(Notification)`
  border-top-color: rgba(246, 175, 9, 1) !important;
  border-radius: 0;
  box-shadow: 0 0 0 0;
  border: 1px solid #c9cdcf;

  .fi-notification_icon-wrapper .fi-icon .fi-icon-base-fill {
    fill: rgba(246, 175, 9, 1) !important;
  }
`;

export const UserInvitationNotification = (
  {
    invitations,
    acceptInvitation,
    rejectInvitation,
    notifActions: { sendSuccessNotification, sendErrorNotification },
    changeOrg
  },
  { intl }
) => {
  const i18n = id => intl.formatMessage({ id });
  const [show, setShow] = React.useState(invitations.length > 0);

  const acceptUserInvitation = async (organisationGuidId, userGuidId) => {
    try {
      const result = await acceptInvitation(organisationGuidId, userGuidId);
      if (result && result.error) {
        throw result;
      }
      sendSuccessNotification(
        'user_invitation_notification.invitation_accept_success',
        '',
        1
      );
      changeOrg(organisationGuidId);
    } catch (e) {
      sendErrorNotification(
        'user_invitation_notification.invitation_accept_error',
        'user_invitation_notification.invitation_error_text',
        1
      );
      console.error(e);
    }
  };

  const rejectUserInvitation = async (organisationGuidId, userGuidId) => {
    try {
      const result = await rejectInvitation(organisationGuidId, userGuidId);
      if (result && result.error) {
        console.log(result);
        throw result;
      }
      sendSuccessNotification(
        'user_invitation_notification.invitation_reject_success',
        '',
        1
      );
    } catch (e) {
      sendErrorNotification(
        'user_invitation_notification.invitation_reject_error',
        'user_invitation_notification.invitation_error_text',
        1
      );
      console.error(e);
    }
  };

  return show ? (
    <StyledNotification
      small
      closeText={i18n('notifications.close')}
      status="neutral"
      onCloseButtonClick={() => setShow(false)}
    >
      {invitations.map(invitation => (
        <StyledContent key={invitation.organisationGuidId}>
          <FormattedMessage
            id="user_invitation_notification.new_invitation"
            values={{
              organisationName: invitation.organisationNameFi
            }}
          />
          <div>
            <Button
              margin="s"
              variant="primary"
              data-test="button-accept"
              onClick={() =>
                acceptUserInvitation(
                  invitation.organisationGuidId,
                  invitation.userGuidId
                )
              }
            >
              <FormattedMessage id="general.accept" />
            </Button>
            <Button
              variant="secondary"
              data-test="button-reject"
              onClick={() =>
                rejectUserInvitation(
                  invitation.organisationGuidId,
                  invitation.userGuidId
                )
              }
            >
              <FormattedMessage id="general.reject" />
            </Button>
          </div>
        </StyledContent>
      ))}
    </StyledNotification>
  ) : null;
};

UserInvitationNotification.propTypes = {
  i18n: PropTypes.object,
  locale: PropTypes.string,
  invitations: PropTypes.array,
  acceptInvitation: PropTypes.func,
  rejectInvitation: PropTypes.func,
  notifActions: PropTypes.shape({
    sendSuccessNotification: PropTypes.func.isRequired,
    sendErrorNotification: PropTypes.func.isRequired
  }),
  changeOrg: PropTypes.func.isRequired
};

UserInvitationNotification.contextTypes = {
  intl: PropTypes.object.isRequired
};
